import type { TOC } from '@ember/component/template-only';

import SkeletonScreenComponent from 'webapp/components/skeleton-screen';

const TeamsViewLoadingRouteTemplate: TOC<object> = <template>
	<SkeletonScreenComponent @type="table" @itemCount={{2}} />
	<SkeletonScreenComponent @type="tiles" @item="board" @itemCount={{4}} />
</template>;

export default TeamsViewLoadingRouteTemplate;
